import { render, staticRenderFns } from "./JurassicPark.vue?vue&type=template&id=0ea23949&"
import script from "./JurassicPark.vue?vue&type=script&lang=js&"
export * from "./JurassicPark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports